<template>
  <LazyDrawer position="right" :is-open="sustainabilityTray" :hide-scroll="false">
    <template #header>
      <Stack tag="div" align="start" justify="end">
        <button @click="closeTray()" class="text-charcoal-default justify-self-end">
          <Icon name="plus-thick" filled class="text-charcoal-default rotate-45" :size="16" />
        </button>
      </Stack>

      <Heading tag="h3" size="xs" class="mt-xs">Sustainable Options</Heading>
    </template>

    <aside class="pt-md px-[24px]">
      <Stack direction="col" gap="sm" v-if="icons.length > 0">
        <Text size="sm" weight="semi">
          This product has {{ icons.length }} sustainable accreditation{{ icons.length > 1 ? "s" : "" }}
        </Text>

        <Stack align="start" justify="between" v-for="(field, index) in icons" :key="index">
          <img :src="`/sustainability/${field.name}.svg`" :alt="`${field.name} accreditation`" />
          <div :id="'field-' + index">
            <Text>
              {{
                SUSTAINABLE_DESCRIPTIONS.find((item: any) => item.name === field.name.replace("icon-", ""))?.description
              }}
            </Text>
          </div>
        </Stack>
      </Stack>
    </aside>
  </LazyDrawer>
</template>

<script lang="ts" setup>
import { SUSTAINABLE_DESCRIPTIONS, availableBadges } from "../../../helpers/sustainability/sustainableDescriptions.js";
const { sustainabilityTray, setSustainabilityTray } = useUIState();

const data = defineProps(["productSustainabilityData"]);

const closeTray = () => {
  setSustainabilityTray();
};

const icons = computed(() => {
  return data.productSustainabilityData.filter(
    ({ name, value }: { name: string; value: any }) => availableBadges.includes(name) && value.includes("Y"),
  );
});
</script>
